import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { GithubPullRequestsProps } from "./types";

export const details = {
  name: "GithubPullRequests",
  description: "Displays a list of your Github pull requests",
  tags: ["Development"],
  category: "Github",
  grid: { default: [3, 3], large: [4, 4] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["github"],
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  defaultProps: {
    filters: {},
  },
} as ElementDetails<GithubPullRequestsProps>;
